export const Vehicle = {
	id: '',
	plate_number: '',
	make: '',
	model: '',
	coding_day: '',
	status: '1',
	capacity: null,
};
